export const dataTypologies = [
    {
        "label": "Ouverture de mur porteur",
        "value": "project-omp"
      },
      {
        "label": "Ouverture de plancher",
        "value": "project-odp"
      },
      {
        "label": "Ouverture de mur semi-porteur",
        "value": "project-omsp"
      },
      {
        "label": "Extension",
        "value": "project-ext"
      },
      {
        "label": "Surélévation",
        "value": "project-sur"
      },
      {
        "label": "Modification de plancher",
        "value": "project-mdp"
      },
      {
        "label": "Portance de plancher",
        "value": "project-pdp"
      },
      {
        "label": "Détermination de la capacité portante",
        "value": "project-dcp"
      },
      {
        "label": "Diagnostic structure",
        "value": "project-diag-str"
      },
      {
        "label": "Diagnostic portance de mur",
        "value": "project-diag-omp"
      },
      {
        "label": "Diagnostic mur semi-porteur",
        "value": "project-diag-omsp"
      },
      {
        "label": "Diagnostic fissuration",
        "value": "project-diag-fiss"
      },
      {
        "label": "Diagnostic post-travaux",
        "value": "project-diag-pt"
      },
      {
        "label": "Modification de charpente",
        "value": "project-mdc"
      },
       {
        "label": "Construction neuve",
        "value": "project-cn"
      },
       {
        "label": "Création de mezzanine",
        "value": "project-cdm"
      },
      {
        "label": "Suivi de travaux",
        "value": "project-suivi"
      }
]